import React, { Component } from "react";
import { Route, Switch } from "react-router";
import { Tabs, Tab } from "material-ui/Tabs";
import { connect } from "react-redux";

import Detail from "./Detail";
import Create from "./Create";
import Users from "./Users";
import Billing from "./Billing";
import Parameter from "./Parameter";
import Tos from "./Tos";
import Accomodation from "./accomodation/Accomodation";
import CSVImport from "./CSVImport";

import Error404 from "../app/Error404";
import { checkPrivileges } from "../auth/privileges";
import auth from "../auth/constants";
import { merchantInfo } from "./actions";

import "./Merchant.css";

import FicheIcon from "material-ui/svg-icons/action/assignment";
import UsersIcon from "material-ui/svg-icons/social/person";
import ParametersIcon from "material-ui/svg-icons/action/settings";
import BillingIcon from "material-ui/svg-icons/action/store";
import TosIcon from "material-ui/svg-icons/editor/attach-file";
import AccomodationIcon from "material-ui/svg-icons/maps/hotel";
import SplitIcon from "material-ui/svg-icons/communication/call-split";

class NotAllowed extends Component {
  render() {
    return <p>Vous n'êtes pas autorisé à utiliser cette page</p>;
  }
}

class Merchant extends Component {
  componentDidMount() {
    this.props.loadInfo(this.props.match.params.merchantCode);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldCompUpdate =
      this.props.detail !== nextProps.detail ||
      this.props.user !== nextProps.user ||
      this.merchantCode !== nextProps.match.params.merchantCode ||
      this.props.location.pathname !== nextProps.location.pathname;
    if (shouldCompUpdate) {
      this.merchantCode = nextProps.match.params.merchantCode;
    }
    return shouldCompUpdate;
  }

  handleActive = tab => {
    this.props.history.push(tab.props.value);
  };

  merchantCode = this.props.match.params.merchantCode;

  isLoadedOrNew = (merchant, urlMerchantCode) =>
    merchant && (merchant.code || urlMerchantCode === "new");

  renderFullMerchantRoutes = (merchant, user) => {
    return (
      <Switch>
        <Route exact path="/configuration/marchands/new" component={Create} />
        <Route
          exact
          path="/configuration/marchands/:merchantCode"
          component={Detail}
        />
        <Route
          exact
          path="/configuration/marchands/new/utilisateurs"
          component={NotAllowed}
        />
        <Route
          exact
          path="/configuration/marchands/new/parametres"
          component={NotAllowed}
        />
        <Route
          exact
          path="/configuration/marchands/:merchantCode/utilisateurs"
          component={Users}
        />
        {checkPrivileges(user.privileges, auth.PARAMETER_MERCHANT_ROUTE) ? (
          <Route
            exact
            path="/configuration/marchands/:merchantCode/parametres"
            component={Parameter}
          />
        ) : (
          <Route
            exact
            path="/configuration/marchands/:merchantCode/parametres"
            component={NotAllowed}
          />
        )}
        <Route
          exact
          path="/configuration/marchands/:merchantCode/facturation"
          component={Billing}
        />
        <Route
          exact
          path="/configuration/marchands/:merchantCode/cgv"
          component={Tos}
        />
        {merchant.kind === "HOT" ? (
          <Route
            exact
            path="/configuration/marchands/:merchantCode/hebergement"
            component={Accomodation}
          />
        ) : (
          <Route
            exact
            path="/configuration/marchands/:merchantCode/hebergement"
            component={NotAllowed}
          />
        )}
        {checkPrivileges(user.privileges, auth.IMPORT_MERCHANT_CSV_ROUTE) ? (
          merchant.kind !== "ESF" && merchant.kind !== "ASSU" ? (
            <Route
              exact
              path="/configuration/marchands/:merchantCode/import-csv"
              component={CSVImport}
            />
          ) : (
            <Route
              exact
              path="/configuration/marchands/:merchantCode/import-csv"
              component={NotAllowed}
            />
          )
        ) : (
          <Route
            exact
            path="/configuration/marchands/:merchantCode/import-csv"
            component={NotAllowed}
          />
        )}
        <Route path="*" component={Error404} />
      </Switch>
    );
  };

  renderReducedMerchantRoutes = (merchant, user) => {
    return (
      <Switch>
        <Route
          exact
          path={`/configuration/marchands/${user.merchant}`}
          component={Detail}
        />
        <Route
          exact
          path="/configuration/marchands/:merchantCode/utilisateurs"
          component={Users}
        />
        {checkPrivileges(user.privileges, auth.PARAMETER_MERCHANT_ROUTE) ? (
          <Route
            exact
            path="/configuration/marchands/:merchantCode/parametres"
            component={Parameter}
          />
        ) : (
          <Route
            exact
            path="/configuration/marchands/:merchantCode/parametres"
            component={NotAllowed}
          />
        )}
        <Route
          exact
          path="/configuration/marchands/:merchantCode/facturation"
          component={Billing}
        />
        <Route
          exact
          path={`/configuration/marchands/${user.merchant}/cgv`}
          component={Tos}
        />
        {merchant.kind === "HOT" ? (
          <Route
            exact
            path="/configuration/marchands/:merchantCode/hebergement"
            component={Accomodation}
          />
        ) : (
          <Route
            exact
            path="/configuration/marchands/:merchantCode/hebergement"
            component={NotAllowed}
          />
        )}
        <Route path="*" component={Error404} />
      </Switch>
    );
  };

  renderMerchant(merchant, user) {
    if (this.isLoadedOrNew(merchant, this.props.match.params.merchantCode)) {
      return checkPrivileges(user.privileges, auth.FULL_MERCHANT_ROUTES)
        ? this.renderFullMerchantRoutes(merchant, user)
        : this.renderReducedMerchantRoutes(merchant, user);
    }
  }

  renderFullTabs = (detail, user) => {
    return (
      <div className="tabs-container">
        <div className="tabs">
          <Tabs value={this.props.location.pathname}>
            <Tab
              value={`/configuration/marchands/${this.merchantCode}`}
              icon={<FicheIcon />}
              onActive={this.handleActive}
            />
            <Tab
              value={`/configuration/marchands/${
                this.merchantCode
              }/facturation`}
              icon={<BillingIcon />}
              onActive={this.handleActive}
              disabled={this.merchantCode === "new"}
            />
            {checkPrivileges(user.privileges, auth.PARAMETER_TAB_DISPLAY) ? (
              <Tab
                value={`/configuration/marchands/${
                  this.merchantCode
                }/parametres`}
                icon={<ParametersIcon />}
                onActive={this.handleActive}
                disabled={this.merchantCode === "new"}
              />
            ) : null}
            {detail.kind !== "ESF" && detail.kind !== "ASSU" ? (
              <Tab
                value={`/configuration/marchands/${
                  this.merchantCode
                }/utilisateurs`}
                icon={<UsersIcon />}
                onActive={this.handleActive}
                disabled={this.merchantCode === "new"}
              />
            ) : null}
            <Tab
              value={`/configuration/marchands/${this.merchantCode}/cgv`}
              icon={<TosIcon />}
              onActive={this.handleActive}
              disabled={this.merchantCode === "new"}
            />
            {detail.kind === "HOT" ? (
              <Tab
                value={`/configuration/marchands/${
                  this.merchantCode
                }/hebergement`}
                icon={<AccomodationIcon />}
                onActive={this.handleActive}
                disabled={this.merchantCode === "new"}
              />
            ) : null}
            {checkPrivileges(
              user.privileges,
              auth.IMPORT_MERCHANT_CSV_TAB_DISPLAY
            ) ? (
              detail.kind !== "ESF" && detail.kind !== "ASSU" ? (
                <Tab
                  value={`/configuration/marchands/${
                    this.merchantCode
                  }/import-csv`}
                  icon={<SplitIcon />}
                  onActive={this.handleActive}
                  disabled={this.merchantCode === "new"}
                />
              ) : null
            ) : null}
          </Tabs>
        </div>
        <div className="tab-content-container">
          {this.renderMerchant(detail, user)}
        </div>
      </div>
    );
  };

  renderReducedTabs = (detail, user) => {
    return (
      <div className="tabs-container">
        <div className="tabs">
          <Tabs value={this.props.location.pathname}>
            <Tab
              value={`/configuration/marchands/${user.merchant}`}
              icon={<FicheIcon />}
              onActive={this.handleActive}
            />
            <Tab
              value={`/configuration/marchands/${
                this.merchantCode
              }/facturation`}
              icon={<BillingIcon />}
              onActive={this.handleActive}
              disabled={this.merchantCode === "new"}
            />
            {checkPrivileges(user.privileges, auth.PARAMETER_TAB_DISPLAY) ? (
              <Tab
                value={`/configuration/marchands/${
                  this.merchantCode
                }/parametres`}
                icon={<ParametersIcon />}
                onActive={this.handleActive}
                disabled={this.merchantCode === "new"}
              />
            ) : null}
            {detail.kind !== "ESF" && detail.kind !== "ASSU" ? (
              <Tab
                value={`/configuration/marchands/${user.merchant}/utilisateurs`}
                icon={<UsersIcon />}
                onActive={this.handleActive}
              />
            ) : null}
            <Tab
              value={`/configuration/marchands/${user.merchant}/cgv`}
              icon={<TosIcon />}
              onActive={this.handleActive}
            />
            {detail.kind === "HOT" ? (
              <Tab
                value={`/configuration/marchands/${
                  this.merchantCode
                }/hebergement`}
                icon={<AccomodationIcon />}
                onActive={this.handleActive}
                disabled={this.merchantCode === "new"}
              />
            ) : null}
          </Tabs>
        </div>
        <div className="tab-content-container">
          {this.renderMerchant(detail, user)}
        </div>
      </div>
    );
  };

  render() {
    const { detail, user } = this.props;
    return checkPrivileges(user.privileges, auth.FULL_TABS_DISPLAY)
      ? this.renderFullTabs(detail, user)
      : this.renderReducedTabs(detail, user);
  }
}

/********* Container part */

const mapStateToProps = state => ({
  detail: state.merchant.detail,
  user: state.app.auth.user
});

const mapDispatchToProps = dispatch => ({
  loadInfo: code => {
    dispatch(merchantInfo(code));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Merchant);



// WEBPACK FOOTER //
// ./src/merchant/Merchant.js